


































































































import { Component, Emit, Prop, PropSync, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { InputAuthor } from '@/components/molecules/InputAuthor'
import { InputSubject } from '@/components/molecules/InputSubject'
import { InputCompleteWorks } from '@/components/molecules/InputCompleteWorks'
import { InputPublisher } from '@/components/molecules/InputPublisher'
import { AtomTextField } from '@/components/atoms'
import { InputCode } from '@/components/molecules/InputCode'

export interface InputContentSearchItem {
  title: {
    input: string
    errorMessage: string
  }
  contentTitle: {
    input: string
    not: boolean
    errorMessage: string
  }
  contentAuthor: {
    id: string
    not: boolean
    input: string
    errorMessage: string
  }
  contentAuthorNos: {
    nos: string[]
    errorMessage: string
  }
  holdingBranchCodes: {
    input: string
    errorMessage: string
  }
}

export const defaultInputContentSearchItem = (): InputContentSearchItem => ({
  title: {
    input: '',
    errorMessage: ''
  },
  contentTitle: {
    input: '',
    not: false,
    errorMessage: ''
  },
  contentAuthor: {
    id: '',
    not: false,
    input: '',
    errorMessage: ''
  },
  contentAuthorNos: {
    nos: [],
    errorMessage: ''
  },
  holdingBranchCodes: {
    input: '',
    errorMessage: ''
  }
})

const NOT_DEFAULT_COLOR: string = 'grey lighten-1'

const NOT_SELECTED_COLOR: string = '#4769CB'

@Component({
  components: {
    InputCode,
    InputAuthor,
    InputSubject,
    InputCompleteWorks,
    InputPublisher
  }
})
export default class BibliographyContentSearch extends ComponentVue {
  @Ref()
  contentTitleTextField!: AtomTextField

  @PropSync('input', {
    type: Object,
    required: true
  })
  inputItem!: InputContentSearchItem

  @Prop({
    type: Boolean,
    default: false
  })
  tooliOnly!: boolean

  get notDefaultColor(): string {
    return NOT_DEFAULT_COLOR
  }

  get notSelectedColor(): string {
    return NOT_SELECTED_COLOR
  }

  focus(): void {
    this.contentTitleTextField.atomTextField.focus()
  }

  notIconColor(bool: boolean): string {
    return bool ? this.notSelectedColor : this.notDefaultColor
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  toggleNotIcon(obj: any): void {
    obj.not = !obj.not
  }

  @Emit('click:search')
  onClickSearch() {}

  @Emit('keydown:enter')
  onKeydownEnter(): void {}
}
